import { TFunction } from 'i18next';
import { TableColumn, TableStyles } from 'react-data-table-component';
import { NavigateFunction } from 'react-router';
import {
  ReservationResponse,
  Workplace,
  WorkplaceReservationsToCancel,
} from 'src/api/wa/store/models/workplace';
import { getDetailStatusTranslationKey } from 'src/api/wa/store/models/workplace/OperationStatus';
import LinkButton from 'src/ui/wards/common/button/LinkButton';
import { WaScreensMap } from 'src/ui/wards/router/WardsScreenMap';
import { wardsNavigate } from 'src/ui/wards/router/WardsScreenRegistration';
import { WA_Screen } from 'src/ui/wards/router/WardsScreens';
import { CancelReservationCell } from './CancelReservationCell';

export const unaddressedSiteTableStyle: TableStyles = {
  table: { style: { border: '1px solid #e3e6e7' } },
  headRow: {
    style: {
      minHeight: '2rem',
      backgroundColor: '#f2f3f3',
    },
  },
  headCells: {
    style: {
      borderBottom: '1px solid #e3e6e7',
      borderRight: '1px solid #e3e6e7',
      fontWeight: 700,
    },
  },
  rows: {
    style: {
      minHeight: '2rem',
    },
    selectedHighlightStyle: {
      backgroundColor: '#e0f2fe',
    },
    highlightOnHoverStyle: {
      backgroundColor: '#bae6fd',
      cursor: 'pointer',
    },
  },
};

export const unaddressedSiteColumns = (
  navigate: NavigateFunction,
  t: TFunction<'translation', undefined>,
  setSelectedSite: (currentSite: Workplace | null) => void,
  cancelWorkplaceReservation: (
    reservationsDetails: WorkplaceReservationsToCancel[]
  ) => Promise<ReservationResponse[] | null | undefined>,
  notify: (messageKey: string) => void
): TableColumn<Workplace>[] => {
  return [
    {
      name: t('wards.common.customerNumber'),
      cell: (row) => (
        <LinkButton
          title={row.customerId}
          onClick={() => {
            setSelectedSite(row);
            wardsNavigate(navigate, WaScreensMap[WA_Screen.WorkplaceDetails].path);
          }}
        />
      ),
      grow: 2,
    },
    {
      name: t('wards.desktop.unaddressedPropertiesList.buildingName'),
      cell: (row) => (
        <div className="items-start">{`${row.emergencyClass ? '★' : ''} ${row.name}`}</div>
      ),
      grow: 2,
    },
    {
      name: t('wards.common.status'),
      cell: (row) => (
        <div className="items-start ps-2">
          {row.details?.statusId ? t(getDetailStatusTranslationKey(row.details?.statusId)) : ''}
        </div>
      ),
      grow: 1,
    },
    {
      name: t('wards.desktop.unaddressedPropertiesList.worker'),
      cell: (row) => (
        <div className="grid grid-cols-1 items-start p-2 md:grid-cols-2">
          <div className="self-center p-2">
            {(row.details?.reservations ?? []).map((reservation) => reservation.engineerName)}
          </div>
          <CancelReservationCell
            row={row}
            cancelWorkplaceReservation={cancelWorkplaceReservation}
            notify={notify}
            t={t}
          />
        </div>
      ),
      grow: 2,
    },
    {
      name: t('wards.desktop.unaddressedPropertiesList.reservationPerson'),
      cell: (_row) => (
        <div className="items-start ps-2">
          {_row.details.reservations.map((reservation) => reservation.reserverName)}
        </div>
      ),
      grow: 1,
    },
    {
      name: t('wards.desktop.unaddressedPropertiesList.address'),
      cell: (row) => <div className="items-start ps-2">{row.address}</div>,
      grow: 3,
    },
    {
      name: t('wards.desktop.unaddressedPropertiesList.comment'),
      cell: (row) => (
        <div className="items-start ps-2">
          {row.details.comment ? t('wards.common.withComment') : t('wards.common.noComment')}
        </div>
      ),
      grow: 1,
    },
  ];
};
